export const stateOn = 'ON';
export const stateOff = 'OFF';

export const stateType = [stateOff, stateOn] as const;
export type StateType = typeof stateType[number];
